import de from './locales/de';

const dateTimeFormats = {
  de,
};

export default dateTimeFormats;
